// Types
import { grey, orange, green, red, blue } from '../../../common/styles/colours';
export var DropdownItemPropertiesByVariant = {
    default: function (theme) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            labelColor: (_a = theme.contentPrimary) !== null && _a !== void 0 ? _a : grey[900],
            prefixColor: (_b = theme.contentAccessory) !== null && _b !== void 0 ? _b : grey[500],
            iconColor: (_c = theme.contentPrimary) !== null && _c !== void 0 ? _c : grey[900],
            backgroundColourHover: (_d = theme.hoverHighlight) !== null && _d !== void 0 ? _d : grey[200],
            activeBackgroundColourHover: (_e = theme.clickedHighlight) !== null && _e !== void 0 ? _e : grey[300],
            disabledColor: (_f = theme.disabledSecondary) !== null && _f !== void 0 ? _f : grey[400],
        });
    },
    orange: function (theme) {
        var _a, _b, _c;
        return ({
            labelColor: (_a = theme.contentPrimary) !== null && _a !== void 0 ? _a : grey[900],
            prefixColor: (_b = theme.contentAccessory) !== null && _b !== void 0 ? _b : grey[500],
            iconColor: orange[700],
            backgroundColourHover: orange[50],
            activeBackgroundColourHover: orange[100],
            disabledColor: (_c = theme.disabledSecondary) !== null && _c !== void 0 ? _c : grey[400],
        });
    },
    green: function (theme) {
        var _a, _b, _c;
        return ({
            labelColor: (_a = theme.contentPrimary) !== null && _a !== void 0 ? _a : grey[900],
            prefixColor: (_b = theme.contentAccessory) !== null && _b !== void 0 ? _b : grey[500],
            iconColor: green[700],
            backgroundColourHover: green[50],
            activeBackgroundColourHover: green[100],
            disabledColor: (_c = theme.disabledSecondary) !== null && _c !== void 0 ? _c : grey[400],
        });
    },
    red: function (theme) {
        var _a, _b, _c;
        return ({
            labelColor: (_a = theme.contentPrimary) !== null && _a !== void 0 ? _a : grey[900],
            prefixColor: (_b = theme.contentAccessory) !== null && _b !== void 0 ? _b : grey[500],
            iconColor: red[700],
            backgroundColourHover: red[50],
            activeBackgroundColourHover: red[100],
            disabledColor: (_c = theme.disabledSecondary) !== null && _c !== void 0 ? _c : grey[400],
        });
    },
    blue: function (theme) {
        var _a, _b, _c;
        return ({
            labelColor: (_a = theme.contentPrimary) !== null && _a !== void 0 ? _a : grey[900],
            prefixColor: (_b = theme.contentAccessory) !== null && _b !== void 0 ? _b : grey[500],
            iconColor: blue[600],
            backgroundColourHover: blue[50],
            activeBackgroundColourHover: blue[100],
            disabledColor: (_c = theme.disabledSecondary) !== null && _c !== void 0 ? _c : grey[400],
        });
    },
};
//# sourceMappingURL=DropdownItemPropertiesByVariant.js.map